import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    IconButton,
    styled,
    Tooltip,
} from "@mui/material";
import clsx from "clsx";
import { useState } from "react";
import { useAppDispatch } from "../../../redux/store";
import { IWithClassName } from "../../../theme/default.theme";
import { RunStatus } from "../enum/run-status";
import { IListBuilderTableDto } from "../interface/dto/list-builder-table-list.dto";
import { listBuilderTableDeleteAction } from "../redux/list-builder-table-page.action";

interface IProps extends IWithClassName {
    listBuilder: IListBuilderTableDto;
}

const DeleteButton = ({ className, listBuilder }: IProps) => {
    const dispatch = useAppDispatch();
    const [open, setOpen] = useState(false);

    const deleteHandler = () => {
        setOpen(false);
        if (listBuilder) {
            dispatch(listBuilderTableDeleteAction(listBuilder.listBuilderId));
        }
    };

    const isButtonDisabled = listBuilder
        ? [RunStatus.Pending, RunStatus.Running].includes(
              listBuilder.lastRunStatus,
          ) && listBuilder.lastRunProgress < 100
        : true;

    return (
        <>
            <Tooltip title="Delete this List Builder">
                <span className={className}>
                    <IconButton
                        onClick={() => setOpen(true)}
                        disabled={isButtonDisabled}
                        className={clsx({ disabledButton: isButtonDisabled })}
                    >
                        <img src="/assets/delete.svg" alt="Delete" />
                    </IconButton>
                </span>
            </Tooltip>
            <Dialog open={open} onClose={() => setOpen(false)}>
                <DialogTitle>Delete this List Builder</DialogTitle>
                <DialogContent>
                    <DialogContentText>
                        Are you sure you want to permanently delete{" "}
                        {listBuilder.listBuilderName}?
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setOpen(false)} color="primary">
                        No, Keep
                    </Button>
                    <Button onClick={deleteHandler} color="primary">
                        Yes, Delete
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    );
};

export default styled(DeleteButton)(() => ({
    ".disabledButton": {
        opacity: 0.5,
    },
}));
